import React from 'react';
import { formatConfidencePercent } from '../lib/networkIntelligenceFormatters';

const cardClass = 'rounded-xl border border-slate-800 bg-slate-900/70 p-4 shadow-sm';

const PredictiveRiskSummaryCards = ({ summary }) => {
  const totalRisks = Number(summary?.totalRisks || 0);
  const highOrCritical = Number(summary?.highOrCriticalRisks || 0);

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
      <div className={cardClass}>
        <div className="text-xs uppercase tracking-wide text-slate-400">Total Risiko Prediktif</div>
        <div className="mt-2 text-2xl font-semibold">{totalRisks}</div>
      </div>

      <div className={cardClass}>
        <div className="text-xs uppercase tracking-wide text-slate-400">Risiko High/Critical</div>
        <div className="mt-2 text-2xl font-semibold text-red-300">{highOrCritical}</div>
      </div>

      <div className={cardClass}>
        <div className="text-xs uppercase tracking-wide text-slate-400">Area Risiko Tertinggi</div>
        <div className="mt-2 text-sm font-semibold">{summary?.topAreaAtRisk || '-'}</div>
      </div>

      <div className={cardClass}>
        <div className="text-xs uppercase tracking-wide text-slate-400">Segmen Akses Risiko Tertinggi</div>
        <div className="mt-2 text-sm font-semibold">{summary?.topAccessSegmentAtRisk || '-'}</div>
      </div>

      <div className={cardClass}>
        <div className="text-xs uppercase tracking-wide text-slate-400">Rata-rata Confidence</div>
        <div className="mt-2 text-2xl font-semibold text-blue-300">{formatConfidencePercent(summary?.averageConfidence || 0)}</div>
      </div>
    </div>
  );
};

export default PredictiveRiskSummaryCards;
